"use client";

// Libraries
import Image from "next/image";
import Link from "next/link";

export default function CreatorCard({ creator, ...props }) {
    return (
        <div className="flex items-center md:flex-row flex-col gap-5 rounded-2xl bg-gray-100 dark:bg-bgDark-840 p-5 lg:max-w-lg lg:w-auto w-full">
            <div>
                <div className="w-[100px] h-[100px] rounded-full overflow-hidden">
                    <Image
                        src={creator.photo}
                        width={100}
                        height={100}
                        alt={`${creator.firstName} ${creator.lastName}`}
                        className="rounded-full object-cover overflow-hidden"
                    />
                </div>
            </div>
            <div className="w-full">
                <div className="dark:text-white text-lg font-bold md:text-left text-center">
                    {creator.firstName} {creator.lastName}
                </div>
                <div className="dark:text-lightBlue">{creator.bio}</div>
                <div className="mt-4 flex md:justify-end justify-center">
                    <Link
                        href={`/u/${
                            creator.pseudo
                                ? creator.pseudo
                                : `believer-${creator.id}`
                        }`}
                    >
                        <div className="inline-flex items-center gap-1">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="M8.512 4.43a.75.75 0 0 1 1.057.082l6 7a.75.75 0 0 1 0 .976l-6 7a.75.75 0 0 1-1.138-.976L14.012 12L8.431 5.488a.75.75 0 0 1 .08-1.057Z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                            Voir ce créateur
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
}
